import styled from 'styled-components';
import TextField from '@mui/material/TextField';

export const TextFieldStyled = styled(TextField)`
  width: 80%;

  & .MuiInputLabel-root {
    color: white;
  }

  & .MuiInputLabel-root.Mui-disabled {
    color: lightgray;
  }

  & .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: white;
  }

  /* Hover state */
  & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #1976d2;
  }
`;

export const SideNavigation = styled.div`
  height: 100%;
  width: 27%;
  padding: ${({ theme }) => theme.spacing[3]};
  color: ${({ theme }) => theme.colors.text.primary};

  ${({ theme }) =>
    theme.mode === 'dark' ? theme.colors.neutral[600] : theme.colors.divider};
`;

export const CardsContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  width: 73%;
  gap: ${({ theme }) => theme.spacing[3]};
  padding: ${({ theme }) => theme.spacing[3]};
`;

export const Line = styled.hr`
  width: 0;
  height: 100%;
  border: none;
  border-left: 2px dotted
    ${({ theme }) =>
      theme.mode === 'dark' ? theme.colors.neutral[600] : theme.colors.divider};
`;

export const PageTitle = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: ${({ theme }) => theme.typography.heading.h1.fontSize};
  font-weight: ${({ theme }) => theme.typography.heading.h1.fontWeight};
  line-height: ${({ theme }) => theme.typography.heading.h1.lineHeight};
  letter-spacing: ${({ theme }) => theme.typography.heading.h1.letterSpacing};
`;
